import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import Logo from "../../assets/images/logo.webp";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { t } from "i18next";
import { useSelector } from "react-redux";
import PathConstants from "../../routes/pathConstants";

const Footer = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  // Get settings from store
  const data = useSelector((state) => state.setting);
  let year = new Date().getFullYear();
  return (
    <Styles>
      <footer>
        <Container>
          <div className="footer-content">
            <div className="footer-links">
              <Link to={`/${PathConstants.PrivacyPolicy}`}>
                {Resource?.privacy_policy
                  ? Resource?.privacy_policy
                  : t("footer.privacy_policy")}
              </Link>
              <Link to={`/${PathConstants.TermsAndConditions}`}>
                {Resource?.Terms_and_conditions
                  ? Resource?.Terms_and_conditions
                  : t("footer.Terms_and_conditions")}
              </Link>
              <Link to="/scientific-certified">
                {Resource?.certified_scientific
                  ? Resource?.certified_scientific
                  : t("certified_scientific")}
              </Link>
              <Link to="/contact-us">
                {Resource?.contact_us
                  ? Resource?.contact_us
                  : t("footer.contact_us")}
              </Link>
            </div>
            <div className="copyrights">
              <span>
                {Resource?.copyright
                  ? Resource?.copyright
                  : t("footer.copyright")}{" "}
                {year}
              </span>
              <div className="social-media">
                {data?.settings?.twitter && (
                  <a target="_blank" href={data?.settings?.twitter}>
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                )}
                {data?.settings?.instagram && (
                  <a target="_blank" href={data?.settings?.instagram}>
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                )}
                {data?.settings?.facebook && (
                  <a target="_blank" href={data?.settings?.facebook}>
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
          <Link to={"/"} className="footer-img">
            <img src={Logo} alt="logo" />
          </Link>
        </Container>
      </footer>
    </Styles>
  );
};

export default Footer;
